import React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { Switch } from 'antd';
import { useDispatch } from 'react-redux';
import { updateProduct,addDirtyProduct } from '../../productmanagement/slices/productsSlice';
export default (props) => {
    const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
    const dispatch = useDispatch();
    const handleOnChange=(value)=>{
        const product =  _.cloneDeep(props.data);
        product.enabled = value;
        dispatch(updateProduct(product));
        dispatch(addDirtyProduct(product));
    };
  return (
    <span>
      <Switch
        checkedChildren={<CheckOutlined />}
        unCheckedChildren={<CloseOutlined />}
        defaultChecked={false}
        checked={cellValue}
        onChange={handleOnChange}
      />
    </span>
  );
};
